export const LEGACY_TYPE_MAP = {
  ETUDIANT: 'VARIABLE',
  FORMATEUR: 'VARIABLE',
  VISITEUR: 'VARIABLE',
  STAFF: 'VARIABLE',
  ETUDIANT_FORMATEUR: 'VARIABLE',
  ETUDIANT_FORMATEUR_STAFF: 'VARIABLE'
};

export const normalizeConsommableType = (type) => LEGACY_TYPE_MAP[type] || type || 'FIXE';

export const calculateConsommableQuantity = (consommable, counts = {}) => {
  const type = normalizeConsommableType(consommable.type_consommable);
  const durationDays = Number(counts.durationDays || 1);
  const visitorDays = Number(counts.visitorDays || 0);
  const students = Number(counts.students || 0);
  const trainers = Number(counts.trainers || 0);
  const visitors = Number(counts.visitors || 0);
  const staff = Number(counts.staff || 0);

  if (type === 'FIXE') {
    const quantity = Number(consommable.quantity_fixe || 0);
    return consommable.is_per_day ? quantity * durationDays : quantity;
  }

  const addDays = (quantity, days) => (consommable.is_per_day ? quantity * days : quantity);
  let total = 0;

  total += addDays(students * Number(consommable.quantity_per_student || 0), durationDays);
  total += addDays(trainers * Number(consommable.quantity_per_trainer || 0), durationDays);
  total += addDays(visitors * Number(consommable.quantity_per_visitor || 0), visitorDays);
  total += addDays(staff * Number(consommable.quantity_per_staff || 0), durationDays);

  return total;
};

export const getConsommableCalculationDetail = (consommable, counts = {}, t) => {
  const type = normalizeConsommableType(consommable.type_consommable);
  const durationDays = Number(counts.durationDays || 1);
  const visitorDays = Number(counts.visitorDays || 0);
  const students = Number(counts.students || 0);
  const trainers = Number(counts.trainers || 0);
  const visitors = Number(counts.visitors || 0);
  const staff = Number(counts.staff || 0);
  const label = (key, fallback) => (t ? t(`consommables.calculation.${key}`) : fallback);
  const fixedLabel = label('fixed', 'fixed');
  const dayShort = label('dayShort', 'd.');
  const studentShort = label('studentShort', 'stu.');
  const trainerShort = label('trainerShort', 'instr.');
  const visitorShort = label('visitorShort', 'vis.');
  const staffShort = label('staffShort', 'staff');
  const perVisitorDayShort = label('perVisitorDayShort', 'd./vis.');

  if (type === 'FIXE') {
    const quantity = Number(consommable.quantity_fixe || 0);
    const total = consommable.is_per_day ? quantity * durationDays : quantity;
    return consommable.is_per_day
      ? `${quantity} ${fixedLabel} × ${durationDays} ${dayShort} = ${total}`
      : `${quantity} ${fixedLabel} = ${total}`;
  }

  const parts = [];
  let total = 0;

  const studentQty = Number(consommable.quantity_per_student || 0);
  if (studentQty) {
    let component = students * studentQty;
    if (consommable.is_per_day) {
      component *= durationDays;
      parts.push(`${students} ${studentShort} × ${studentQty} × ${durationDays} ${dayShort}`);
    } else {
      parts.push(`${students} ${studentShort} × ${studentQty}`);
    }
    total += component;
  }

  const trainerQty = Number(consommable.quantity_per_trainer || 0);
  const staffQty = Number(consommable.quantity_per_staff || 0);
  if (trainerQty || staffQty) {
    let component = (trainers * trainerQty) + (staff * staffQty);
    if (consommable.is_per_day) {
      component *= durationDays;
      if (trainerQty && staffQty && trainerQty === staffQty) {
        parts.push(`(${trainers} ${trainerShort} + ${staff} ${staffShort}) × ${trainerQty} × ${durationDays} ${dayShort}`);
      } else {
        const group = [];
        if (trainerQty) group.push(`${trainers} ${trainerShort} × ${trainerQty}`);
        if (staffQty) group.push(`${staff} ${staffShort} × ${staffQty}`);
        parts.push(`(${group.join(' + ')}) × ${durationDays} ${dayShort}`);
      }
    } else if (trainerQty && staffQty && trainerQty === staffQty) {
      parts.push(`(${trainers} ${trainerShort} + ${staff} ${staffShort}) × ${trainerQty}`);
    } else {
      if (trainerQty) parts.push(`${trainers} ${trainerShort} × ${trainerQty}`);
      if (staffQty) parts.push(`${staff} ${staffShort} × ${staffQty}`);
    }
    total += component;
  }

  const visitorQty = Number(consommable.quantity_per_visitor || 0);
  if (visitorQty) {
    let component = visitors * visitorQty;
    if (consommable.is_per_day) {
      component *= visitorDays;
      parts.push(`${visitors} ${visitorShort} × ${visitorQty} × ${visitorDays} ${perVisitorDayShort}`);
    } else {
      parts.push(`${visitors} ${visitorShort} × ${visitorQty}`);
    }
    total += component;
  }

  return `${parts.join(' + ')} = ${total}`;
};

export const getDisplayType = (type) => normalizeConsommableType(type);

export const formatConsommableRule = (consommable, t) => {
  const type = normalizeConsommableType(consommable.type_consommable);
  if (type === 'FIXE') {
    return consommable.quantity_fixe || 0;
  }

  const parts = [];
  if (consommable.quantity_per_student) {
    parts.push(`${consommable.quantity_per_student || 0}${t('consommables.perStudentShort')}`);
  }
  if (consommable.quantity_per_trainer) {
    parts.push(`${consommable.quantity_per_trainer || 0}${t('consommables.perTrainerShort')}`);
  }
  if (consommable.quantity_per_visitor) {
    parts.push(`${consommable.quantity_per_visitor || 0}${t('consommables.perVisitorShort')}`);
  }
  if (consommable.quantity_per_staff) {
    parts.push(`${consommable.quantity_per_staff || 0}${t('consommables.perStaffShort')}`);
  }

  return parts.join(' + ') || '0';
};
